import { withStyles } from '@material-ui/core';

import TopBar from './component';
import styles from './styles';

export default withStyles(styles)(TopBar);
